import React, { useContext } from 'react';
import {AddToCart} from "./AddToCart/AddToCart";
import {AddToWishlist} from "./AddToWishlist/AddToWishlist";
import {ProductContext} from '../../../../pages/ProductStencil';
import {isEcommerceEnabled} from '../../../../../selectors/generic';

export const Actions = () => {
    const {SapDetails} = useContext(ProductContext);

    if(!isEcommerceEnabled() || SapDetails[0]?.IsObsolete) {return null}

    return (
        <div className="pdp__actions">
            <AddToCart/>
            <AddToWishlist/>
        </div>
    );
}
